import type { RegionMiniEntity } from '@/features/region/domain/entities/RegionMiniEntity'
import type { ShiftType } from '@/features/shiftTemplate/domain/enums/ShiftType'

export class CreateUpdateShiftEntity {
  startDateTime?: Date
  duration?: string
  size?: number
  type?: ShiftType
  region?: RegionMiniEntity
}
